import { Auth } from '@nackle/bridge';
import { idURL } from './endpoints';

const auth = new Auth( {
    authority: idURL,
    companyId: '2eddede7-12e0-493a-ba36-3940b96b1cac'
} );

export default auth;
